import { CommonConstants } from '../../../data/BackendEntityConstants';

/**
 * Fixed RFI back-end data
 */
export function generateRFIRequestCommon() {
  return {
    rfxRequestClassId: { value: 'AWSRFIRequest' },
    rfxResponseClassId: { value: 'AWSRFIResponse' },
    rfxLineItemClassId: { value: 'AWSRFQLineItem' },
    type: 'RFI',
    region: { value: CommonConstants.UNSET_REGION_VALUE },
    currency: 'USD'
  };
}
